// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconImageApertureMedium_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM20.321 17.5481C18.5842 20.1479 15.6614 21.8879 12.3261 21.9948L17.8129 13.7995L20.321 17.5481ZM21.3656 15.5128L16.4236 8.12646L16.4195 8.12922L16.3333 8H21.1679C21.7031 9.22493 22 10.5778 22 12C22 13.2361 21.7757 14.4199 21.3656 15.5128ZM13.9296 8H10.0704L7.40383 12.0002L9.02661 14.4344L10.0851 16H13.9296L16.5963 12L13.9296 8ZM20.0007 6C18.5456 4.06278 16.4033 2.67121 13.9358 2.18722L11.3978 6H20.0007ZM7.36601 15.549L2.61916 8.52809C2.21874 9.6096 2 10.7793 2 12C2 13.4222 2.2969 14.7751 2.83209 16H7.66667L7.36601 15.549ZM3.99927 18C5.45036 19.9319 7.58485 21.3211 10.0438 21.8088L12.5938 18H3.99927ZM6.18179 10.2267L11.6539 2.00588C8.31127 2.11957 5.38486 3.87377 3.65452 6.48866L6.18179 10.2267Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM28.0577 23.1185C25.8254 26.8916 21.8726 29.5262 17.2793 29.9423L20.9878 24H21L24.8151 17.8958L28.0577 23.1185ZM18.6303 24L14.9118 29.9583C10.6054 29.6273 6.84455 27.3478 4.50938 24H18.6303ZM19.8784 22L22.3748 17.9999L22.3869 18.0074L23.6397 16.0028L23.1103 15.15L19.8915 10H12.1158L11.5898 10.836L11.5871 10.8343L8.35849 16L12.1085 22L19.8784 22ZM29.0868 20.9843C29.6768 19.4358 30 17.7556 30 16C30 13.8528 29.5166 11.8185 28.6527 10H22.2669L24.8078 14.0926L26 16L25.9961 16.0063L29.0868 20.9843ZM13.3741 8L17.121 2.04423C21.4137 2.38433 25.1614 4.66071 27.4906 8H13.3741ZM14.7514 2.05492L11.0112 8H11L7.17421 14.1213L3.91995 8.91937C6.15313 5.11763 10.1297 2.46338 14.7514 2.05492ZM2.89779 11.0565C2.31752 12.5936 2 14.2597 2 16C2 18.1472 2.48338 20.1815 3.34726 22H9.74397L2.89779 11.0565Z" class="svg-bg"/>
</svg>
`;
/**
 * IconImageApertureMedium is a generated icon component.
 */
let IconImageApertureMedium = IconImageApertureMedium_1 = class IconImageApertureMedium extends IconBaseElement {
    render() {
        return html `${IconImageApertureMedium_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconImageApertureMedium.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconImageApertureMedium = IconImageApertureMedium_1 = __decorate([
    customElement('zui-icon-image-aperture-medium')
], IconImageApertureMedium);
export { IconImageApertureMedium };
